<template>
    <div
        class="py-2"
    >
        <b-container
            fluid
            class="lga-header"
        >
            <b-row
                class="lga-header-row"
            >
                <b-col
                    md="3"
                    class="lga-site-title d-flex flex-column justify-content-center"
                >
                    <h1
                        class="align-self-center"
                    >
                        {{ localStaticParts.siteTitle }}
                    </h1>
                </b-col>
                <b-col
                    md="6"
                    class="lga-header-title d-flex flex-column justify-content-center border-left"
                >
                    <p
                        class="mb-2  text-uppercase "
                    >
                        {{ localStaticParts.seminarNomination }}
                    </p>
                    <h2
                        class=""
                    >
                        {{ localStaticParts.seminarTitle }}
                    </h2>
                    <h3>
                        {{ localStaticParts.seminarSubtitle }}
                    </h3>
                    <p>{{ localStaticParts.seminarBy }}<br>{{ localStaticParts.coopWith }}</p>
                </b-col>
                <b-col
                    md="3"
                    class="lga-logos flex d-flex-column justify-content-center"
                >
                    <b-img
                        right
                        fluid
                        class="block"
                        src="/img/fu_logo_web.png"
                    />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'siteHeader',
  components: {
        
  },
  data () {
      return {
          
      }
  },
  methods: {
      ...mapActions({

    })
  },
  computed: {
    ...mapGetters({
        localStaticParts: 'getLocalStaticParts',
        staticParts: 'getStaticParts'
    })
  },
  created () {
      
  } 
}
</script>
<style scoped>
.lga-header-title {
     
}
.lga-site-title {
    color: #003366;
    font-style: italic;
}
.lga-logos img {
    max-width: 100%;
}
.lga-header h1 {
    font-size: 1.8rem;
    padding-right: .4rem
}
.lga-header h2 {
    font-size: 1.2rem;
    margin: 0 0 .2rem 0
}
.lga-header h3 {
    font-size: 1rem;
    margin: 0 0 .6rem 0
}
</style>
